import { isString } from 'lodash';

const removeNonDigitsAndCountryCodes = (phoneNumberString) => {
  const nonCountryCodedString = phoneNumberString.replace(/^\+[0-9]/, '');
  const cleaned = nonCountryCodedString.replace(/\D/g, '');
  return cleaned;
};

export const formatPhoneNumber = (phoneNumberString) => {
  if (isString(phoneNumberString) === false) {
    return null;
  }
  const cleaned = removeNonDigitsAndCountryCodes(phoneNumberString);

  const matches = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (matches) {
    return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }
  return null;
};
